import React from "react";
import { useState } from "react";
import { Button, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import SearchBar from "../../components/SearchBar";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useNavigate } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';

const UserTopbar = () => {

  const [searchTerm, setSearchTerm] = useState("");
  const [Status, setStatus] = React.useState('default');
  const navigate = useNavigate();
  const handleStatusChange = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };

  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <SearchBar
            searchTerm={searchTerm}
            setDebouncedSearchTerm={setSearchTerm}
            placeholder="Search..."
          />
          <div className=" form">
            <Select
              fullWidth
              value={Status}
              onChange={handleStatusChange} >
              <MenuItem disabled value="default">Select Status</MenuItem>
              <MenuItem value="All">All</MenuItem>
              <MenuItem value="Active">Active</MenuItem>
              <MenuItem value="Suspended">Suspended</MenuItem>
            </Select>
          </div>
          <div className="form">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                className="form_control"
                slots={{
                  openPickerIcon: () => <img src="/static/images/date_icon.svg" alt="Pick date" />,
                }}
                slotProps={{
                  textField: {
                    id: "dob",
                    placeholder: "Select Date",
                    fullWidth: true,
                    hiddenLabel: true,
                  },
                }}
                desktopModeMediaQuery="(min-width:0px)"
              />
            </LocalizationProvider>
          </div>
        </div>
        <div className="right_s">
          <Button onClick={() => navigate('/manage-users/add')} className="btn btn_primary"><AddIcon /> Add User</Button>
        </div>
      </div>
    </>
  );
};

export default UserTopbar;
